import { ENV_VALUES } from '@/config/env';
import Vue from 'vue';
// import VueFullscreen from 'vue-fullscreen';
import axios, { AxiosError } from 'axios';
import VueYouTubeEmbed from 'vue-youtube-embed';
// @ts-expect-error there is no ts declaration file
import Ripple from 'vue-ripple-directive';
// @ts-expect-error there is no ts declaration file
import VueSignaturePad from 'vue-signature-pad';
// @ts-expect-error there is no ts declaration file
import VueEditor from 'vue2-editor';
import App from './App.vue';
import i18n from './i18n';
import vuetify from './plugins/vuetify';
import router from './router/index';
import authStore from './store/AuthStore';

// Sets 'test.informme.info' base_url for development (don't remove)

console.log(`Started in ${ENV_VALUES.NODE_ENV} mode`);
if (ENV_VALUES.NODE_ENV !== 'production') {
  const apiUrl = 'https://test.informme.info';
  // const apiUrl = 'http://localhost:3000'; // node
  // const apiUrl = 'http://localhost:3002'; // bunduril
  console.log(`Started in Development mode. Using ${apiUrl} as base url`);
  axios.defaults.baseURL = apiUrl;
}

// Add axios response interceptor to handle token expiration
axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Check if error is 401 (Unauthorized) which typically indicates token expiration
    if (error.response?.status === 401) {
      // Check if error message indicates token expiration
      const errorData = error.response?.data;
      let isTokenExpired = false;

      if (typeof errorData === 'string') {
        isTokenExpired =
          errorData.includes('TokenExpiredError') || errorData.includes('jwt expired');
      } else if (errorData && typeof errorData === 'object') {
        const errorMessage =
          (errorData as Record<string, unknown>).message ||
          (errorData as Record<string, unknown>).error ||
          JSON.stringify(errorData);
        isTokenExpired =
          (typeof errorMessage === 'string' &&
            (errorMessage.includes('TokenExpiredError') || errorMessage.includes('jwt expired'))) ||
          JSON.stringify(errorData).includes('TokenExpiredError') ||
          JSON.stringify(errorData).includes('jwt expired');
      }

      if (isTokenExpired) {
        // Handle token expiration
        authStore.handleTokenExpiration();
      }
    }
    return Promise.reject(error);
  },
);

Vue.use(VueSignaturePad);
Vue.use(VueEditor);
// Ripple.color = 'rgba(53, 64, 136, 0.5)';  // blue
Ripple.color = 'rgba(103, 173, 112, 0.5)'; // green
// Ripple.color = 'rgba(255, 255, 255, 0.35)'; // white
// Ripple.zIndex = 55;
Vue.directive('ripple', Ripple);

Vue.config.productionTip = false;

// Vue.use(VueFullscreen);
Vue.use(VueYouTubeEmbed);

new Vue({
  router,
  i18n,
  vuetify,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render: (h) => h(App),
}).$mount('#app');
